import ajax from './ajax'

/**
 * 获取轮播广告
 */
export const queryBanners = (params) => {
  return ajax({
    url: '/public/v1/banner',
    params: params
  })
}

/**
 * 获取二级导航
 */
export const querySecondNavs = (params) => {
  return ajax({
    url: '/public/v1/getSecCategory',
    params: params
  })
}

/**
 * 获取二级导航
 */
export const queryImages = (params) => {
  return ajax({
    url: '/public/v1/com/image/queryImages',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/axios/com.js